/* eslint-disable jsdoc/check-param-names */
import { getFetch } from './env';
import _ from 'lodash';

// eslint-disable-next-line jsdoc/require-param
/**
 * make RESTful API call
 * @param method {String} - 'GET' or 'POST'
 * @param requestUrl {String} - url connected with the endpoint defined above.
 * @param payload {Object} - request body.
 * @param headers - header params.
 * @param mode ''
 * @param jsonize ''
 * @returns ''
 */
export const makeApiCall = async ({ method, requestUrl, payload = undefined, headers = undefined, mode = 'cors', jsonize = true }: any) => {
  // logger.debug('make API call to AWS API Gateway');
  const fetch: any = getFetch();

  const body: any = payload && jsonize ? JSON.stringify(payload) : payload || undefined;
  try {
    const response: any = await fetch(requestUrl, {
      method,
      body,
      headers,
      mode,
    });
    let success = false;
    if (response.status >= 200 && response.status < 300) {
      success = true;
      if (!jsonize) {
        return response;
      }
    }

    const responseJson = await response.json();
    if (success) {
      return responseJson;
    } else {
      const err = Object.assign({ status: response.status, statusText: response.statusText }, responseJson);
      throw new Error(JSON.stringify(err));
    }
  } catch (e) {
    console.log('error');
    console.log(e);
  }
};

/**
 * `
 * @param idToken トークン情報
 * @param url URL
 * @param header ヘッダー
 * @param payload payload
 */
export const createOptions = (idToken: string | undefined, url: string, header: any | undefined, payload: any = undefined) => {
  const options: any = {
    method: 'POST',
    requestUrl: url,
    headers: { 'Content-Type': 'application/json' },
    mode: 'cors',
  };
  if (header !== undefined) {
    Object.assign(options.headers, header);
  }
  if (payload !== undefined) {
    options.payload = payload;
  }
  if (idToken !== undefined) {
    options.headers.Authorization = `Bearer ${idToken}`;
  }
  return options;
};

/**
 * `
 * @param array `
 * @param getKey `
 */
export const groupBy = <K, V>(array: readonly V[], getKey: (cur: V, idx: number, src: readonly V[]) => K): [K, V[]][] =>
  Array.from(
    array.reduce((map, cur, idx, src) => {
      const key = getKey(cur, idx, src);
      const list = map.get(key);
      if (list) list.push(cur);
      else map.set(key, [cur]);
      return map;
    }, new Map<K, V[]>())
  );

/**
 * stringとnumberソートの比較関数（これ以外の型のソートは現状使わないので必要に応じて実装変更）
 * @param a {string | number | undefined}
 * @param b {string | number | undefined}
 * @param asc {boolean}
 */
export const compare = (a: string | number | undefined, b: string | number | undefined, asc: boolean) => {
  if (a === undefined || a === '') return 1;
  if (b === undefined || b === '') return -1;
  if (a === b) return 0;
  if (asc) {
    if (a < b) return 1;
    if (a > b) return -1;
  } else {
    if (a > b) return 1;
    if (a < b) return -1;
  }
  return 0;
};

/**
 * 指定したキーを取り除いたオブジェクトを返す
 * @param obj {object}
 * @param key {key}
 */
export const removeKey = <T>(obj: T, key: keyof T) => {
  // @ts-ignore
  const { [key]: removed, ...res } = obj;
  return res;
};
